module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.showTitle) ? _c('title-card') : _vm._e(), _vm._v(" "), _c('background-video'), _vm._v(" "), _c('color-filter-overlay', {
    staticClass: "color-filter-overlay",
    attrs: {
      "active": _vm.playing
    }
  }), _vm._v(" "), _c('mount-synth', {
    on: {
      "attackStart": _vm.attackStart,
      "releaseStart": _vm.releaseStart
    }
  }), _vm._v(" "), (_vm.playbackEnded) ? _c('newsletter-signup') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2c2e7f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/player.vue
// module id = 289
// module chunks = 1